/**
 * Shared by CalendarsPage and AlertsPage — was two near-identical copies.
 * `editUrl`/`templateLabel` are computed by the caller (each page has its
 * own `getEditUrl`/`TEMPLATE_LABELS`, genuinely different per domain, so
 * not unified here). `disabledReason` is alerts-only (plan-downgrade
 * auto-disable) — omit it for calendars.
 */
import React from "react";
import classNames from "classnames";
import { Link } from "react-router-dom";
import {
  formatDateTimeLong,
  formatDateShort,
} from "../../../../helpers/formatters";
import Icon from "../../theme/untitled/icons/Icon";
import styles from "./TableRow.module.scss";

const TableRow = ({
  item,
  editUrl,
  templateLabel,
  disabledReason,
  renderStatus,
  renderMenu,
  isPublishing = false,
}) => {
  const integrationLabel = item.integration ? (
    item.integration.type.toUpperCase()
  ) : (
    <span className={styles.integration_disconnected}>Disconnected</span>
  );
  const mobileMeta = [
    integrationLabel,
    templateLabel,
    item.modified ? formatDateShort(item.modified * 1000) : "—",
  ].join(" · ");

  return (
    <tr
      className={classNames(styles.row, {
        [styles["row--publishing"]]: isPublishing,
      })}
    >
      <td className={styles.td}>
        <Link to={editUrl} className={styles.cellLink}>
          <span className={styles.nameCell}>
            <span className={styles.name}>
              {disabledReason && (
                <span className={styles.disabledIcon} title={disabledReason}>
                  <Icon name="AlertTriangle" size={14} />
                </span>
              )}
              {item.name}
            </span>
            <span className={styles.integration}>{integrationLabel}</span>
            <span className={styles.mobileMeta}>{mobileMeta}</span>
          </span>
        </Link>
      </td>
      <td className={classNames(styles.td, styles.templateCell)}>
        <Link to={editUrl} className={styles.cellLink}>
          {templateLabel}
        </Link>
      </td>
      <td
        className={classNames(
          styles.td,
          styles.lastEdited,
          styles.lastEditedCell
        )}
      >
        <Link to={editUrl} className={styles.cellLink}>
          {item.modified ? (
            formatDateTimeLong(item.modified * 1000)
          ) : (
            <span className={styles.lastEditedEmpty}>&mdash;</span>
          )}
        </Link>
      </td>
      <td className={styles.td}>{renderStatus(item)}</td>
      <td className={classNames(styles.td, styles.actionsCell)}>
        {!isPublishing && renderMenu(item)}
      </td>
    </tr>
  );
};

export default TableRow;
